import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalization } from '@progress/kendo-react-intl';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import * as SC from './locationSearch.styled';
import { rootState } from '@core-interface';
import { Loading } from 'app-styled/components';


const LocationSearch = ({ fullWidth, btm = false, onSearch, locationAddress, placeholder, latLang: defaultlatLng }) => {
  const localization = useLocalization();
  const [address, setAddress] = useState(locationAddress ? locationAddress : '');
  const [latLng, setLatLng] = useState(defaultlatLng);
  const [gmapsLoaded, setGmapsLoaded] = useState(false);

  const {
    coreReducer: { mapLoaded },
  } = useSelector((state: rootState) => state);

  useEffect(() => {
    setGmapsLoaded(mapLoaded);
  }, [mapLoaded]);

  useEffect(() => {
    let isMounted = true;
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => isMounted && setLatLng(latLng))
      .catch(error => console.error('Error', error));
      return () => {
        isMounted = false; 
      }
  }, [address])

  const handleChange = address => {
    setAddress(address);
  };

  const handleSelect = address => {
    setAddress(address);
  };

  useEffect(() => {
    onSearch(address, latLng);
  }, [JSON.stringify(latLng), JSON.stringify(address)]);

  return (
    <>
      {gmapsLoaded && (
        <SC.LocationSearchWrapper className={"popupHeight"}>
          <PlacesAutocomplete
            value={address}
            onChange={handleChange}
            onSelect={handleSelect}
          >
            {({
              getInputProps,
              suggestions,
              getSuggestionItemProps,
              loading,
            }) => (
              <SC.LocationWrapper fullWidth>
                <SC.LocationSearch
                  {...getInputProps({
                    placeholder: placeholder ? placeholder :
                      `${localization.toLanguageString('your_location', 'Your Location')} ...`,
                    className: 'location-search-input',
                  })}
                />
                <SC.LocationDrop
                  className="autocomplete-dropdown-container"
                  btm={btm ? true : undefined}
                >
                  {loading && <SC.LocationData><Loading /></SC.LocationData>}
                  {suggestions.map((suggestion, index) => {
                    return (
                      <SC.LocationData
                        key={index}
                        {...getSuggestionItemProps(suggestion)}
                      >
                        {suggestion.description}
                      </SC.LocationData>
                    );
                  })}
                </SC.LocationDrop>
              </SC.LocationWrapper>
            )}
          </PlacesAutocomplete>
        </SC.LocationSearchWrapper>
      )}
    </>
  )
}

export default LocationSearch;
